(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-carousel"] && !Shopify.designMode) return;
  try {
    
(() => {
  function setup(rail) {
    if (rail.dataset.railReady) return;
    rail.dataset.railReady = '1';
    const track = rail.querySelector('[data-rail-track]');
    const prev = rail.querySelector('[data-rail-prev]');
    const next = rail.querySelector('[data-rail-next]');
    if (!track || !prev || !next) return;
    const dir = () => getComputedStyle(track).direction === 'rtl' ? -1 : 1;
    const update = () => {
      const max = track.scrollWidth - track.clientWidth;
      const pos = Math.abs(track.scrollLeft);
      prev.disabled = pos <= 2;
      next.disabled = pos >= max - 2;
    };
    const step = sign => track.scrollBy({ left: sign * dir() * track.clientWidth * 0.9, behavior: 'smooth' });
    prev.addEventListener('click', () => step(-1));
    next.addEventListener('click', () => step(1));
    track.addEventListener('scroll', () => requestAnimationFrame(update), { passive: true });
    window.addEventListener('resize', update);
    update();
  }
  const init = root => (root || document).querySelectorAll('[data-rail]').forEach(setup);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init()); else init();
  document.addEventListener('shopify:section:load', e => init(e.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
/* Fareeqi: close (X) button for the currency converter price notice */
(function () {
  var KEY = 'fq-hide-price-notice';
  var root = document.documentElement;
  var css = '.bacurr-checkoutNotice .big-ol-cart-notice{padding-inline-end:46px!important}' +
    '.fq-notice-close{position:absolute;top:50%;inset-inline-end:10px;transform:translateY(-50%);width:30px;height:30px;display:flex;align-items:center;justify-content:center;padding:0;background:transparent;border:0;border-radius:50%;color:inherit;font-size:24px;line-height:1;cursor:pointer;opacity:.65}' +
    '.fq-notice-close:hover,.fq-notice-close:focus-visible{opacity:1;background:rgba(0,0,0,.08)}' +
    'html.fq-notice-hidden .bacurr-checkoutNotice{display:none!important}';
  var st = document.createElement('style');
  st.textContent = css;
  document.head.appendChild(st);
  try { if (sessionStorage.getItem(KEY) === '1') root.classList.add('fq-notice-hidden'); } catch (e) {}
  function addCloseButtons() {
    document.querySelectorAll('.bacurr-checkoutNotice .big-ol-cart-notice').forEach(function (box) {
      if (box.querySelector('.fq-notice-close')) return;
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'fq-notice-close';
      b.setAttribute('aria-label', (root.lang || '').indexOf('ar') === 0 ? '\u0625\u063A\u0644\u0627\u0642' : 'Close');
      b.textContent = '\u00D7';
      b.addEventListener('click', function () {
        root.classList.add('fq-notice-hidden');
        try { sessionStorage.setItem(KEY, '1'); } catch (e) {}
      });
      box.appendChild(b);
    });
  }
  addCloseButtons();
  new MutationObserver(addCloseButtons).observe(document.body, { childList: true, subtree: true });
})();

  } catch(e) { console.error(e); }
})();
})();
